import React, { useMemo } from "react";

// others

import { Col, Row, Spin } from "antd";
import { calculatePaidAmountAndDueDate, finalMoveOutSettlemet } from "../../BookingForm/components/utils";
import { Item } from "../../BookingForm/components/view";

import { apiDateFormat } from "../../BookingForm/components/utils";
import { useTotalOverpaymentAmount } from "../../Contracts/PostDatedCheques/ModifyPaymentStatus/hook/useTotalOverpaymentAmount";
import { formatCurrency } from "../../../libs/utils";
import {
  getLinkedInvoiceAmount,
  getOtherReceivablesTotal,
  resolveLinkedInvoicesFromSummary,
} from "../../BookingForm/components/modalContent/EditTerminationProcess.utils";

interface IProps {
  booking: any;
  kycDetails?: Array<object>;
}

const TerminationDetail = (props: IProps) => {
  // variables

  const isBooking = props?.booking && Object.keys(props.booking).length > 0;

  const { totalOverpaymentRemaining } = useTotalOverpaymentAmount(props?.booking?.tenantId);
  const _ = require("lodash");

  const { totalPaidAmount, lastPaidDate, securityDepositAmount, securityDepositDate } = useMemo(
    () => calculatePaidAmountAndDueDate(props.booking?.paymentSchedule),
    [props?.booking?.actualRentDue]
  );
  // for caculate finalSettlementAmount
  // intentional comment out the final settlement amount calculation please do not remove this comment and code
  const settlementAmount: any = useMemo(
    () => finalMoveOutSettlemet(props?.booking, securityDepositAmount, totalPaidAmount, totalOverpaymentRemaining),
    [
      props?.booking?.actualRentDue,
      props?.booking?.settlementSummary?.otherReceivables,
      securityDepositAmount,
      totalPaidAmount,
      totalOverpaymentRemaining,
    ]
  );
  const linkedInvoices = useMemo(
    () =>
      resolveLinkedInvoicesFromSummary(
        props?.booking?.paymentSchedule || [],
        props?.booking?.settlementSummary?.linkedInvoices || [],
      ),
    [props?.booking?.paymentSchedule, props?.booking?.settlementSummary?.linkedInvoices],
  );
  const terminationTotal = linkedInvoices.terminationCharges
    ? getLinkedInvoiceAmount(linkedInvoices.terminationCharges)
    : props?.booking?.termination?.totalterminationPaneltyAmount;
  const maintenanceFee = linkedInvoices.maintenanceFee
    ? getLinkedInvoiceAmount(linkedInvoices.maintenanceFee)
    : props?.booking?.settlementSummary?.maintenancefee;
  const refurbishmentFee = linkedInvoices.refurbismentFee
    ? getLinkedInvoiceAmount(linkedInvoices.refurbismentFee)
    : props?.booking?.settlementSummary?.refurbismentfee;
  const otherAdminFee = linkedInvoices.adminFee
    ? getLinkedInvoiceAmount(linkedInvoices.adminFee)
    : props?.booking?.settlementSummary?.otheradminfee;
  const overstayTotal = linkedInvoices.Overstay
    ? getLinkedInvoiceAmount(linkedInvoices.Overstay)
    : props?.booking?.overstay?.totalOverStayPaneltyAmount;
  const otherReceivables = getOtherReceivablesTotal(linkedInvoices);

  const format = "DD-MMM-YYYY";

  return (
    <Col span={24} className="view-booking">
      {!isBooking && (
        <Row gutter={24} className="loading">
          <Spin size="large" />
        </Row>
      )}

      {isBooking && (
        <>
          <Row gutter={24} className="bd-item">
            <Item label="Penalty Type" value={_.capitalize(props?.booking?.moveOutType)} />
            <Item
              renewalAmout={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                apiDateFormat(props?.booking?.oldSettlementSummary?.vacatingDate, format)
              }
              label="Move-out Date"
              value={props?.booking?.vacatingDate ? apiDateFormat(props?.booking?.vacatingDate, format) : "-"}
              settlementSummary={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                apiDateFormat(props?.booking?.settlementSummary?.props?.booking?.vacatingDate, format)
              }
            />
            <Item
              label="Move-out Inspection Date"
              value={
                props?.booking?.moveOutInspection
                  ? apiDateFormat(props?.booking?.moveOutInspection["date"], format)
                  : "-"
              }
            />
            <Item
              label="Lease Term"
              value={`${props?.booking?.leaseTermDays ? props?.booking?.leaseTermDays : 0} days |  ${formatCurrency(
                props?.booking?.leaseTerms?.contractAmount,{showZeros:true}
              )}`}
            />

            <Item
              label="Days Occupied"
              value={`${props?.booking?.daysOccupied ? props?.booking?.daysOccupied : 0} Days`}
            />

            <Item
              label="Rent Per Day"
              value={` ${ formatCurrency(props?.booking?.rentPerDay,{showZeros:true}) }`}
            />

            <Item label="Security Deposit" value={`${securityDepositDate} |  ${securityDepositAmount}`} />
            <Item label="Rent Received Until " value={`${lastPaidDate}  |  ${formatCurrency(totalPaidAmount,{showZeros:true})}`} />
            <Item
              label="Actual Rent Due"
              value={`${props?.booking?.daysOccupied ? props?.booking?.daysOccupied : 0} days |  ${
                formatCurrency(props?.booking?.actualRentDue,{showZeros:true})
              }`}
            />
            <Item label="Overpayment Credit" value={` ${formatCurrency(totalOverpaymentRemaining,{showZeros:true})}`} />
            <Item
              renewalAmout={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                props?.booking?.oldSettlementSummary?.maintenancefee
              }
              label="Maintenance Fee"
              settlementSummary={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                props?.booking?.settlementSummary?.maintenancefee
              }
              value={` ${formatCurrency(props?.booking?.settlementSummary?.maintenancefee,{showZeros:true})}`}
            />
            <Item
              renewalAmout={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                props?.booking?.oldSettlementSummary?.refurbismentfee
              }
              label="Refurbishment Fee"
              value={` ${formatCurrency(props?.booking?.settlementSummary?.refurbismentfee,{showZeros:true})}`}
              settlementSummary={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                props?.booking?.settlementSummary?.refurbismentfee
              }
            />

            <Item
              renewalAmout={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                props?.booking?.oldSettlementSummary?.otheradminfee
              }
              label="Other / Admin Fee"
              value={` ${formatCurrency(props?.booking?.settlementSummary?.otheradminfee,{showZeros:true})} `}
              settlementSummary={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                props?.booking?.settlementSummary?.otheradminfee
              }
            />

            <Item
              label="Overstay"
              value={`${props?.booking?.overstay?.numberOfDays ? props?.booking?.overstay?.numberOfDays : 0} days |  ${formatCurrency(
                props?.booking?.overstay?.totalOverStayPaneltyAmount,{showZeros:true}
              )}`}
            />

            <Item
              label="Termination Charge"
              value={`${
                props?.booking?.termination?.numberOfDays ? props?.booking?.termination?.numberOfDays : 0
              } days |  ${formatCurrency(terminationTotal,{showZeros:true})}`}
            />

            <Item
              renewalAmout={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                props?.booking?.oldSettlementSummary?.deduction
              }
              label="Deduction / Waiver"
              value={` ${formatCurrency(props?.booking?.settlementSummary?.deduction,{showZeros:true})} `}
              settlementSummary={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                props?.booking?.settlementSummary?.deduction
              }
            />

            <Item
              renewalAmout={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                -Number(props?.booking?.oldSettlementSummary?.otherReceivables || 0)
              }
              label="Other Receivables"
              value={` ${formatCurrency(-Number(otherReceivables || 0), {
                showZeros: true,
              })} `}
              settlementSummary={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                -Number(props?.booking?.settlementSummary?.otherReceivables || 0)
              }
            />

            <Item
              renewalAmout={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                props?.booking?.oldSettlementSummary?.settlementAmount
              }
              label="Settlement Amount"
              value={` ${formatCurrency( props?.booking?.settlementSummary?.settlementAmount || settlementAmount || 0,{showZeros:true})} `}
              settlementSummary={
                props?.booking?.oldSettlementSummary &&
                props?.booking?.settlementApproval === "pending" &&
                props?.booking?.settlementSummary?.settlementAmount
              }
            />
          </Row>
        </>
      )}
    </Col>
  );
};

export default TerminationDetail;
